export const BOOKING_EQUIPEMENTS = 'BOOKING_EQUIPEMENTS';
export const BOOKING_ROOMS = 'BOOKING_ROOMS';
export const BOOKING_USERS = 'BOOKING_USERS';
export const BOOKING_CURRENT_SELECTION = 'BOOKING_CURRENT_SELECTION';
export const LOCATION_TAG = 'Locations';
export const EQUIPMENT_HARDWARE_TAG = 'EquipmentHardware';
export const BOOKING_EQUIPMENT_TAG = 'BookingEquipment';
export const CHANGE_CURRENT_MONTH = 'CHANGE_CURRENT_MONTH';

/**
 * Sets the booking equipments of active project
 * @param bookingEquipments
 * @returns {{type: string, bookingEquipments: *}}
 */
export const setBookingEquipments = bookingEquipments => {
  return {
    type: BOOKING_EQUIPEMENTS,
    bookingEquipments
  };
};

/**
 * Sets the booking rooms of active project
 * @param bookingRooms
 * @returns {{type: string, bookingRooms: *}}
 */
export const setBookingRooms = bookingRooms => {
  return {
    type: BOOKING_ROOMS,
    bookingRooms
  };
};

/**
 * Sets current selection day
 * @param selection
 * @returns {{type: string, selection: *}}
 */
export const setBookingCurrentSelection = selection => {
  return {
    type: BOOKING_CURRENT_SELECTION,
    selection
  };
};

export const setCurrentMonth = currentMonth => {
  return {
    type: CHANGE_CURRENT_MONTH,
    currentMonth
  };
};

/**
 * Fetch booking equipments by project
 * @param projectId
 * @param callback
 * @returns {function(*, *, {apiClient: *}): boolean}
 */
export const fetchBookingEquipmentsByProject = (projectId, callback) => {
  return async (dispatch, getState, { apiClient }) => {
    const equipmentHardwares = await apiClient.call(
      EQUIPMENT_HARDWARE_TAG,
      'getProjectEquipmentHardwares',
      { projectId }
    );

    dispatch(setBookingEquipments(equipmentHardwares));

    callback && callback();

    return true;
  };
};

/**
 * Fetch booking rooms by project
 * @param projectId
 * @returns [{}]
 */
export const fetchBookingRoomsByProject = (projectId, callback) => {
  // To do : utiliser l'api pour récupèrer les bonnes data
  return async (dispatch, getState, { apiClient }) => {
    const res = await apiClient.call(LOCATION_TAG, 'getLocations', {});

    let bookingRooms = res.data;
    bookingRooms = bookingRooms.map(bookingRoom => {
      bookingRoom.bookings = [];
      return bookingRoom;
    });

    dispatch(setBookingRooms(bookingRooms));

    callback && callback();

    return true;
  };
};

export const bookEquipment = (
  date,
  equipmentHardwareInstanceId,
  dataAcquisitionSourceEquipmentId,
  callback
) => {
  const bookingObject = {
    date,
    equipment_hardware_instance_id: equipmentHardwareInstanceId,
    data_acquisition_source_equipment_id: dataAcquisitionSourceEquipmentId
  };

  return async (dispatch, getState, { apiClient }) => {
    await apiClient.call(BOOKING_EQUIPMENT_TAG, 'createBookingEquipment', {}, bookingObject);

    const projectId = getState().projects.single.active.id;

    dispatch(fetchBookingEquipmentsByProject(projectId));

    callback && callback();

    return true;
  };
};

export const unbookEquipment = (booking, callback) => {
  return async (dispatch, getState, { apiClient }) => {
    await apiClient.call(BOOKING_EQUIPMENT_TAG, 'deleteBookingEquipment', { id: booking.id });

    const projectId = getState().projects.single.active.id;

    dispatch(fetchBookingEquipmentsByProject(projectId));

    callback && callback();

    return true;
  };
};

export const setNextMonthBooking = callback => {
  return async (dispatch, getState, { apiClient }) => {
    const currentMonth = getState().projects.single.booking.currentMonth.clone();

    currentMonth.add(1, 'M');

    dispatch(setCurrentMonth(currentMonth));

    callback && callback();

    return true;
  };
};

export const setPreviousMonthBooking = callback => {
  return async (dispatch, getState, { apiClient }) => {
    const currentMonth = getState().projects.single.booking.currentMonth.clone();

    currentMonth.subtract(1, 'M');

    dispatch(setCurrentMonth(currentMonth));

    callback && callback();

    return true;
  };
};



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/data/booking/bookingActions.js